import {strCode} from '../../../consts/strCode';
import AiAssistantLoaderIcon from '../../Icons/AiAssistantIcons/AiAssistantLoaderIcon';
import AiAssistantWidgetText from '../AiAssistantWidgetText';

const AiAssistantWidgetConfirmation = () => (
    <div className='flex items-center justify-center gap-2'>
        <AiAssistantLoaderIcon className='h-12 w-12 shrink-0' />

        <AiAssistantWidgetText
            strCode={strCode.AI_ASSISTANT_WAITING_CONFIRMATION_PLACEHOLDER}
            className='text-12 leading-4'
        />
    </div>
);

export default AiAssistantWidgetConfirmation;
